import { useMemo } from 'react'
import { Cell, Column } from 'react-table'
import { useIntl } from 'react-intl'

import { HomeConfigRowStyle } from '../../HomeConfigFiles/styles'
import { Table, DateCell, DownloadButtonCell } from 'components/Table'
import { HomeActiveConfig } from 'features/home/types'
import { ConfigNameCell } from '../../components/ConfigNameCell'
import { MobileHomeActiveConfig } from './MobileHomeActiveConfig'
import { homeActiveConfigurationMessages } from '../../messages'

interface HomeActiveConfigTableProps {
  data: HomeActiveConfig[]
}

const DEFAULT_SORT_BY = { id: 'name', desc: false }

const ActionsCell = (cell: Cell<HomeActiveConfig>) => {
  const config = cell.row.original

  if (config) {
    const { name, location } = config
    const fileName = `${name}.tar.gz`
    return <DownloadButtonCell url={location?.url} fileName={fileName} />
  }
}

function HomeActiveConfigTable(props: HomeActiveConfigTableProps) {
  const { formatMessage } = useIntl()
  const { data } = props

  const columns: readonly Column<HomeActiveConfig>[] = useMemo(
    () => [
      {
        Header: formatMessage(homeActiveConfigurationMessages.name),
        accessor: 'name',
        Cell: ConfigNameCell,
      },
      {
        Header: formatMessage(homeActiveConfigurationMessages.updated),
        accessor: 'updated',
        Cell: DateCell,
      },
      {
        Header: '',
        accessor: 'versionHash',
        disableSortBy: true,
        id: 'actions',
        Cell: ActionsCell,
        width: 90,
      },
    ],
    [formatMessage]
  )

  return (
    <Table
      columns={columns}
      data={data}
      defaultSortBy={DEFAULT_SORT_BY}
      rowStyles={HomeConfigRowStyle}
      mobileViewComponent={MobileHomeActiveConfig}
    />
  )
}

export default HomeActiveConfigTable
